import { ADD_JUNCTURE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_JUNCTURE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_JUNCTURE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_JUNCTURE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
